import React, { useState, useEffect, useCallback, useMemo } from 'react';
import axios from 'axios';
import { format } from 'date-fns';

import Chart from './Chart.js';
import PieChart from './PieChart.js';
import ProjectDuration from './ProjectDuration.js';
import DashboardCal from './Calendar.js';
import PgcNotifTable from './PgcNotifTable.js';
import VicNotifTable from './VicNotifTable.js';
import RjNotifTable from './RjNotifTable.js';
import ContractNotifTable from './ContractNotifTable.js';
import FacNotifTable from './FacNotifTable.js';
import LoadingOverlay from '../LoadingOverlay';
import Header from '../Header/Header';
import RdvSection from './RdvSection.js';
import authHeader from '../Utils';
import history from '../Routes/history';

import '../../Styles/Dashboard/Connexion.scss';
import '../../Styles/Dashboard/NotifList.scss';

const Dashboard = ({ location }) => {
  const [state, setState] = useState({
    idnotif: '',
    rdv: [],
    facture: [],
    activites: [],
    opportunites: [],
    gestdoc: [],
    notif: [],
    dl: [],
    displayNotif: [],
    notifNonVue: [],
    date: new Date(),
    tooltip: { visible: false, content: '', x: 0, y: 0 },
    isLoading: false,
  });

  const showTooltip = useCallback((event, content) => {
    const tooltipContent = content.id
      ? `<b>Dossier</b>: ${content.ndossier}<br><b>Lot</b>: ${content.lot}<br><b>Entreprise</b>: ${content.company}<br><b>Contact</b>: <span>${content.representative}</span><br><b>Téléphone</b>: <span>${content.tel}</span><br><b>Email</b>: <span>${content.mail}</span>`
      : `<b>Titre</b>: ${content.title}<br><b>RDV</b>: ${format(new Date(content.start), 'HH:mm')}<br><b>Description</b>: ${content.description}`;

    setState(prev => ({
      ...prev,
      tooltip: {
        visible: true,
        content: tooltipContent,
        x: event.clientX,
        y: event.clientY,
      },
    }));
  }, []);

  const hideTooltip = useCallback(() => {
    setState(prev => ({
      ...prev,
      tooltip: { visible: false, content: '', x: 0, y: 0 },
    }));
  }, []);

  const getDate = useCallback((newDate) => {
    setState(prev => ({ ...prev, date: newDate }));
  }, []);

  const stripHtml = useCallback((html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
  }, []);

  const fetchAppointments = useCallback(async () => {
    setState(prev => ({ ...prev, isLoading: true }));
    const user = authHeader();
    if (!user['x-access-token']) {
      history.push('/login');
      return;
    }

    try {
      const { data } = await axios.get('/api/getAllAppointments', {
        params: { idUser: user.id, today: state.date },
      });
      setState(prev => ({ ...prev, rdv: data }));
    } catch (err) {
      console.error(err);
    } finally {
      setState(prev => ({ ...prev, isLoading: false }));
    }
  }, [state.date]);

  useEffect(() => {
    fetchAppointments();
  }, [fetchAppointments]);

  const dailyAppointments = useMemo(() =>
    state.rdv.filter(r => format(new Date(r.start), 'yyyy-MM-dd') === format(new Date(state.date), 'yyyy-MM-dd')),
    [state.rdv, state.date]
  );

  return (
    <div className="connexion">
      {state.isLoading && <LoadingOverlay />}
      <Header location={location} />

      <div className="dashboard">
        <RdvSection
          dailyAppointments={dailyAppointments}
          tooltip={state.tooltip}
          onShowTooltip={showTooltip}
          onHideTooltip={hideTooltip}
          stripHtml={stripHtml}
        />

        <div className="calendar">
          <label className="titrecal">Calendrier</label>
          <DashboardCal date={getDate} />
        </div>

        <div className="pendingChantier">
          <label className="titrechantier">Chantiers en cours</label>
          <ProjectDuration />
        </div>

        <div className="graphChantier">
          <label className="titregraph">Chantiers par ville et dossier</label>
          <Chart />
        </div>

        <div className="graphs">
          {/* <label className="titregraphs">Graphiques</label>
          <PieChart /> */}
          <div className="pgc-notif">
            <label className="pgc-label">PGC</label>
            <PgcNotifTable />
          </div>
        </div>

        <div className="docs">
          <div className="titredocs">Documents</div>
          <div className="vic-notif">
            <label className="vic-label">VIC</label>
            <VicNotifTable />
          </div>

          <div className="rj-notif">
            <label className="rj-label">RJ</label>
            <RjNotifTable />
          </div>

          <div className="contract-notif">
            <label className="contract-label">Contrat</label>
            <ContractNotifTable />
          </div>

          <div className="fac-notif">
            <label className="fac-label">Facture</label>
            <FacNotifTable />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;